import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";

export const apiCall = (command, otherData = {}, timeout) => {
  return new Promise((resolve, reject) => {
    const c2f = utils.cookie.get("currentAuth");
    if (c2f) {
      ajax
        .call({
          timeout,
          data: {
            command: command,
            c2f,
            ...otherData,
          },
        })
        .then((resp) => {
          const xml = new DOMParser().parseFromString(resp, "text/xml");
          const result = utils.xmlToJson(xml);
          resolve(result);
        })
        .fail((err) => {
          console.log(err, command, { ...otherData });
          reject(err);
        });
    } else {
      reject({ message: "Not logged in" });
    }
  });
};

const callApiAndResolve = (command, data = {}, timeout) => {
  return new Promise((resolve, reject) => {
    apiCall(command, data, timeout)
      .then((result) => {
        resolve(result?.commandResult?.response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const uploadChunkXHR = (
  url,
  callbacks = {
    loadEvent: () => {},
    abortEvent: () => {},
    errorEvent: () => {},
  },
  formData
) => {
  let xhr = new XMLHttpRequest();

  xhr.addEventListener("load", (evt) => {
    callbacks.loadEvent(evt, xhr);
  });

  xhr.addEventListener("abort", (evt) => {
    callbacks.abortEvent(evt, xhr);
  });

  xhr.addEventListener("error", (evt) => {
    callbacks.errorEvent(evt, xhr);
  });

  xhr.open("POST", url, true);

  callbacks.beforeXhrSend(xhr);

  xhr.send(formData);
};

const timeout = 3600 * 1000;
export const openFile = (data = {}) =>
  callApiAndResolve("openFile", data, timeout);
export const closeFile = (data = {}) =>
  callApiAndResolve("closeFile", data, 10000000, true);
export const checkFileExist = (data = {}) =>
  callApiAndResolve("stat", data, timeout);
export const isFileOpen = (data = {}) =>
  callApiAndResolve("isOpen", data, timeout);
export const blockUploads = (data = {}) =>
  callApiAndResolve("blockUploads", data, timeout);
export const unblockUploads = (data = {}) =>
  callApiAndResolve("unblockUploads", data, timeout);
export const doFilesExists = (data = {}) =>
  callApiAndResolve("exists", data, timeout);
export const makeDir = (data = {}) =>
  callApiAndResolve("makedir", data, timeout);

export const chunkAckXHR = (data = {}) =>
  callApiAndResolve("ackd", data, timeout);

export const getAltDomainToken = () =>
  callApiAndResolve(
    "loginDomain1",
    { random: crypto.getRandomValues(new Uint32Array(1))[0] },
    timeout
  );
